import React from 'react';
import { QueryProvider } from './providers/query-provider';
import { ErrorBoundary } from './components/error-boundary';
import { AppRouter } from './router';
import './index.css';

function App() {
  return (
    <ErrorBoundary>
      <QueryProvider>
        <div className="App">
          <AppRouter />
        </div>
      </QueryProvider>
    </ErrorBoundary>
  );
}

export default App;